import React, { useEffect } from "react";
import { ResponsiveHeader } from "pages/_components/header";
import MainContainer from "pages/_components/MainContainer";
import { useGetAccounts } from "hooks/useAccounts";
import useGetDebinAccounts from "hooks/useDebin";
import PageLoading from "pages/_components/PageLoading";
import Notification from "pages/_components/Notification";
import gaEventTracker, { events } from "util/gaEventTracker";
import DebinListElement from "./DebinListElement";

const AddAccountDebin = () => {
    const { accounts } = useGetAccounts();
    const { debinAccounts, fetching, fetchAccounts } = useGetDebinAccounts();

    useEffect(() => {
        gaEventTracker.triggerEvent(events.debin_adherir_cuentas());
        fetchAccounts();
    }, []);

    const accountInDebin = (accountNumber) => {
        let res = false;
        debinAccounts.forEach((debinAccount) => {
            if (debinAccount?.accountNumber === accountNumber) {
                res = true;
            }
        });
        return res;
    };

    const getSwitchValue = (account) => {
        if (debinAccounts.length === 0) {
            return false;
        }
        return accountInDebin(account?.accountNumber);
    };

    return (
        <>
            <Notification scopeToShow="addNewVendorAccountDebin" />
            <ResponsiveHeader id="debin.addAccount.title" backLinkTo="/debinPayments" />
            <PageLoading loading={fetching}>
                <MainContainer className="addAcountTable">
                    {!fetching ? (
                        accounts.map((data) => (
                            <DebinListElement account={data} switchInitialState={getSwitchValue(data)} />
                        ))
                    ) : (
                        <span>Cargando cuentas...</span>
                    )}
                </MainContainer>
            </PageLoading>
        </>
    );
};

export default AddAccountDebin;
